<medrecord-questions-list-item (click)="questionSelected(question)"
                               *ngFor="let question of questions | enabledQuestions; trackBy: trackByFn"
                               [completed]="question.isCompleted"
                               [idk]="question.hasIdkAnswer"
                               [visited]="question.isVisited"
                               [question]="question.title"
                               [selected]="selectedQuestionId === question.id"
></medrecord-questions-list-item>
